import pagination from "../static/pagination";
import posted from "../static/posted";
import exportData from "../static/exportData";

import settlement from "./mutationSettlement";
import riwayatPembayaran from "./mutationRiwayatPembayaran";

export default {
    ...settlement,
    ...riwayatPembayaran,
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
    setLoadMore: (state, payload) => {
        state.isLoadMore = payload;
    },
    setResponse: (state, payload) => {
        state.response = payload;
    },
    setIdAkunEdc: (state, payload) => {
        state.posted.idakun_keuangan_edc = payload;
    },
    setListProvider: (state, payload) => {
        state.listProvider = [];
        payload.forEach((provider) => {
            state.listProvider.push({ id: provider.id, text: provider.nama });
        });
    },
    setListOutlet: (state, payload) => {
        state.listOutlet = [];
        payload.forEach((outlet) => {
            state.listOutlet.push({ id: outlet.idoutlet, text: outlet.nama });
        });
    },
    setListSettlement: (state, payload) => {
        state.listSettlement = [];
        payload.forEach((akun) => {
            let keterangan = `<span>Atas nama: ${akun.pemilik_rekening}</span>`;
            if (akun.keterangan) {
                keterangan += `<br/><span>Keterangan: ${akun.keterangan}</span>`;
            }
            keterangan += `<br/><span>Kode akun: ${akun.idakun_keuangan}</span>`;

            state.listSettlement.push({
                value: akun.id,
                title: `${akun.nama} - ${akun.nomor_rekening}`,
                information: keterangan,
            });
        });
    },
    setListMesin: (state, payload) => {
        state.listMesinEdc = state.listMesinEdc.concat(payload);
    },
    setListMesinAll: (state, payload) => {
        state.listMesinEdcAll = payload;
    },
    setDataMesin: (state, payload) => {
        state.dataMesinEdc = payload;
    },
    setDetailMesin: (state, payload) => {
        state.detailMesin = payload;
    },
    setSelectedPosted: (state, payload) => {
        state.posted[payload.target] = payload.val;
    },
    setNominalPosted: (state, payload) => {
        state.posted[payload.target] = payload.val;
    },
    setChange: (state, payload) => {
        state.hasChange = payload;
    },
    setPosted: (state, payload) => {
        state.posted = {
            active: 1,
            idakun_keuangan_edc: payload.idakun_keuangan_mesin_edc,
            nama_mesin_edc: payload.nama_mesin_edc,
            idoutlet: payload.idoutlet,
            idakun_keuangan_settlement: parseInt(payload.rekening_owner.id),
            idprovider: parseInt(payload.idprovider),
            persen_sesama_edc: payload.persen_biaya_sesama_provider,
            persen_berbeda_provider: payload.persen_biaya_berbeda_provider,
            persen_kartu_kredit: payload.persen_biaya_kartu_kredit,
        };
    },
    resetPagination: (state) => {
        state.pagination = pagination();
    },
    resetPosted: (state) => {
        state.posted = posted();
    },
    resetResponse: (state) => {
        state.response = {};
    },
    resetListMesin: (state) => {
        state.listMesinEdc = [];
    },
    resetDataMesin: (state) => {
        state.dataMesinEdc = {
            data: [],
            total: 0,
            saldo: 0,
            tglAwal: "",
            tglAkhir: "",
        };
    },
    toogleDisplayCard: (state, payload) => {
        let etIdx = state.displayCard.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.displayCard.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.displayCard.splice(etIdx, 1);
        }
    },
    setLastItemToView: (state, payload) => {
        state.lastItemToView = payload;
    },
    setNextPagination: (state, payload) => {
        state.pagination.length += payload.length;
        state.pagination.pageNumber++;
        state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
    },
    setEndItemOfPage: (state, payload) => {
        state.endItemOfPage = payload;
    },
    setEndSettlementOfPage: (state, payload) => {
        state.endSettlementOfPage = payload;
    },
    setLastSettlementToView: (state, payload) => {
        state.lastSettlementToView = payload;
    },
    resetExportData: (state) => {
        state.exportData = exportData();
    },
    setExporting: (state, payload) => {
        state.exportData.exporting = payload;
    },
    setMinimized: (state, payload) => {
        state.exportData.minimized = payload;
    },
    setMultiple: (state, payload) => {
        state.exportData.multiple = payload;
    },
    setData: (state, payload) => {
        state.exportData.data = payload;
    },
    setDataLength: (state, payload) => {
        state.exportData.dataLength = payload;
    },
    setExportProgress: (state, { processed, total }) => {
        state.exportProgress.processed = Number(processed);
        state.exportProgress.total = Number(total);
    },
};
